import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ToggleSwitchComponent } from './toggle-switch.component';

@NgModule({
  declarations: [ToggleSwitchComponent],
  imports: [FormsModule, CommonModule],
  exports: [ToggleSwitchComponent],
})
export class ToggleSwitchModule {}
